class Toast {
  success(message: string) {
    window.alert(message) // $util.successToast(message)
  }
  error(message: string) {
    window.alert(message) // $util.errorToast(message)
  }
  warning(message: string) {
    window.alert(message) // $util.warningToast(message)
  }
}

export const $toast = new Toast()
